import React, { useContext, useState } from "react";
import { LoginProps } from "./models";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { CgLogIn } from "react-icons/cg";
import Context from "../../utils/context";
import { useNavigate } from "react-router-dom";
import { useOutsideClick } from "../../utils/useOutsideClick";

export const Login = (props:LoginProps) => {
  const { instance } = useMsal();
  const context = useContext(Context);
  
  const isAuthenticated = useIsAuthenticated();
  const [dropdown, setDropdown] = useState(false);

  const navigate = useNavigate()

  const handleLogin = () => {
    instance.loginRedirect();
  };

  const handleLogout = () => {
    instance.logout();
  };

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  const content = useOutsideClick(() => {
      setDropdown(false);
  });

  return (
    <div className="flex items-center cursor-pointer relative">
      {isAuthenticated
      ? 
        <>
          <div className="pr-2">
            <img className="h-8 w-8 object-contain border rounded-full hover:text-text-link" src={context.account.pictureUrl} alt={context.account.username} onClick={() => setDropdown(!dropdown)} />
          </div>
          <div className="block text-white hover:text-text-link" onClick={() => setDropdown(!dropdown)}>
            {context.account.username}
          </div>
        </>
      :
      <>
          <div className="pr-2 text-white" onClick={handleLogin}>
            <CgLogIn size={22} />
          </div>
          <div className="block text-white" onClick={handleLogin}>
            Login
          </div>
        </>
      }
      
      {dropdown ?
        <div ref={content} className="absolute right-0 z-10 w-56 top-5 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none mt-8" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex={-1}>
          <div className="my-4" role="none">
            <button className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full hover:text-text-link" role="menuitem" tabIndex={-1} onClick={() => handleNavigation("account/profile")}>Account</button>
            <button className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full hover:text-text-link" role="menuitem" tabIndex={-1} onClick={() => handleNavigation("admin/users")}>Admin</button>
            <button className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full hover:text-text-link" role="menuitem" tabIndex={-1} onClick={handleLogout}>Logout</button>
          </div>
        </div>
      : null }
    </div>
  );
};